import { queryClient } from '@/lib/queryClient'
import { useDraftsStore } from '@/store/draftsStore'
import { draftsDb } from '@/services/draftsDb'

// Keys that outlive a logout. Theme is a device preference, and the two
// internal_access_* keys belong to InternalGate — the dev/stage environment
// gate, which is a separate layer from app auth. Wiping them logged the user
// out of the gate as well, and losing the device id changed the device
// fingerprint, so every app logout cost a fresh email OTP round-trip.
const PRESERVED_LOCAL_STORAGE_KEYS = new Set([
 'scribenza_theme',
 'internal_access_token',
 'internal_access_device_id',
])

export async function clearSessionState() {
 queryClient.clear()

 useDraftsStore.setState({ drafts: [], loaded: false })
 await draftsDb.clearAll()

 const keysToRemove = []
 for (let i = 0; i < localStorage.length; i += 1) {
  const key = localStorage.key(i)
  if (key && !PRESERVED_LOCAL_STORAGE_KEYS.has(key)) keysToRemove.push(key)
 }

 keysToRemove.forEach(key => localStorage.removeItem(key))
 sessionStorage.clear()
}
